import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import styles from './ScrollTopButton.module.scss';

const SCROLL_SHOW_OFFSET = 320;

const ScrollTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > SCROLL_SHOW_OFFSET);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <button type="button" className={clsx(styles.button, isVisible && styles.buttonVisible)} onClick={scrollToTop} aria-label="Вернуться наверх">
      <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
        <path d="M0 0h24v24H0z" fill="none" />
        <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m18 15l-6-6l-6 6" />
      </svg>
    </button>
  );
};

export default ScrollTopButton;
